export const supportMeasureEntryKeys = {
  all: ['supportMeasureEntries'],

  details: () => [...supportMeasureEntryKeys.all, 'detail'],

  detail: (id: number) => [...supportMeasureEntryKeys.details(), id],

  filterStudents: (id: number) => [...supportMeasureEntryKeys.all, 'filter-students', id],
};
